export const SYNTH_TYPES = [
    'pad',
    'Synth',
    'piano',
    'string',
    'guitar',
    'organ',
    'harm',
    "clap",
    "tom",
    "rim",
    'flute',
    'snare',
    'bass',
    'perc',
    'bazz',
    'hi-hat',
    'kick',
    'lead',
    'key',
    'rhodes',
    'poly',
    'koto',
    'pluck'
];
